<template>
<div>   
   <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <div v-if="$route.params.language === 'en'" >
       
      <div class="col-12 px-0 pt-1 text-center">
        <div class="col-md-6 row mx-0 p-3">
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH Controller</div>
              <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
          </button>&nbsp;
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">CaRx</div>
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">Controller</div>
              <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
          </button>
        </div>			
      </div>
       
      <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0" >
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_EN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_EN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:4000px; frameborder:0; overflow-y:scroll; scrolling:no;" 
            ></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
        <div class="col-12 px-0 pt-0" >
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_EN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
          
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_EN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:13000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
       </div></div>
  </div>

  <div v-if="$route.params.language === 'vi'" >
       
       <div class="col-12 px-0 pt-1 text-center">
         <div class="col-md-6 row mx-0 p-3">
           <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
               <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH Controller</div>
               <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
           </button>&nbsp;
           <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
               <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">CaRx</div>
               <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">Controller</div>
               <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
           </button>
         </div>			
       </div>
        
       <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0" >
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_VN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_VN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:4000px; frameborder:0; overflow-y:scroll; scrolling:no;" 
            ></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
        <div class="col-12 px-0 pt-0" >
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_EN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
          
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_EN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:13000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
       </div></div>
   </div>
   
   <div v-if="$route.params.language === 'ms'" >
       
       <div class="col-12 px-0 pt-1 text-center">
         <div class="col-md-6 row mx-0 p-3">
           <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
               <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH Controller</div>
               <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
           </button>&nbsp;
           <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
               <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">CaRx</div>
               <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">Controller</div>
               <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
           </button>
         </div>			
       </div>
        
       <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0" >
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_MA_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_MA_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:4000px; frameborder:0; overflow-y:scroll; scrolling:no;" 
            ></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
        <div class="col-12 px-0 pt-0" >
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_EN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
          
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_EN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:13000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
       </div></div>
   </div>

   <div v-else-if="$route.params.language === 'cn'" lang="zh-Hans">
    <div class="col-12 px-0 pt-1 text-center">
        <div class="col-md-6 row mx-0 p-3">
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH控制器</div>
              <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
          </button>&nbsp;
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">鈣反控制器</div>
              <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
          </button>
        </div>			
      </div>

       <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0" >
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_CN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_CN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:4000px; frameborder:0; overflow-y:scroll; scrolling:no;" 
            ></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
        <div class="col-12 px-0 pt-0" >
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_CN_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
          
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_CN_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:13000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
       </div></div>
  </div>
  <div v-else-if="$route.params.language === 'tw'" lang="zh-Hans">
      <div class="col-12 px-0 pt-1 text-center">
        <div class="col-md-6 row mx-0 p-3">
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH控制器</div>
              <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
          </button>&nbsp;
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">鈣反控制器</div>
              <div class="col-12 px-0 py-2 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
          </button>
        </div>			
      </div>
       
      <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0" >
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_TW_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA_TW_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:4000px; frameborder:0; overflow-y:scroll; scrolling:no;" 
            ></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
        <div class="col-12 px-0 pt-0" >
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_TW_ppt.pptx"
              width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
          
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA_TW_doc.docx?page=hsn#toolbar=0"
              style="width:100%; height:13000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
       </div></div>

    
  </div>

</div>
</template>
<script>
export default {
  data: () => {
    return {
      isShow: "A"     // display KHA installation

      
    }
  }
}
</script>



// WEBPACK FOOTER //
// Product.vue?e0a72086